<!--
2022-09-22 Matt Promotion规则，读取静态文件内容
-->
<template>
  <div class="promotionRulePage">
    <div>
      <TopBack :title="$t('lang.promotion.rules')" />
    </div>

    <div class="promotionRuleBody">
      <img
        class="introduceImg"
        :alt="promotion.name"
        :src="promotion.introduceImg"
        :key="promotion.name"
      >

      <div class="rules" v-html="ruleHtml">
      </div>

      <div class="buttons-block" v-show="promotion.ButtonText">
        <div class="play-btn"
        :class="{invalid: this.promotion.key === 'SaturdayMembersDay' && !$store.state.membersDayDeposit}"
        @click="gotoRoute(promotion.path)"
        >
          <span>
            {{ promotion.ButtonText }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import store from '@/store/store'

export default {
  name: 'PromotionRule',
  components: {
    TopBack
  },
  data () {
    return {
      promotion: {},
      ruleHtml: ''
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    gotoRoute: function (path) {
      if (this.promotion.key === 'wheelGame') { // 在Home页打开转盘游戏
        sessionStorage.setItem('ShowLuckyWheelGamePop', true)
        this.$router.push(path)
      } else if (this.promotion.key === 'SaturdayMembersDay') {
        if (store.state.membersDayDeposit) {
          this.$router.push(path)
        }
      } else {
        this.$router.push(path)
      }
    },
    loadData: function () {
      this.userInfo = localStorage.getItem('userInfo')
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      if (!this.userInfo) {
        cid = null
      }
      const url = 'innovation/home/promotion/get/one'
      let param = 'local=' + (localStorage.getItem('locale') || 'EN') + '&client=app&campaignId=' + cid + '&key=' + this.$route.query.key
      let fullUrl = url + '?' + param
      request('get', fullUrl).then(res => {
        let item = res.Result
        this.promotion = {
          ...item,
          startUpPopup: item.SequenceNo,
          name: item.Name,
          category: item.Category.split(','),
          key: item.KeyText,
          path: item.Url,
          type: item.PromotionType,
          introduceImg: item.Cover
        }
        this.ruleHtml = this.promotion.Content
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .promotionRulePage {
    padding:56px 0 0 0;
    background-color: rgba(0,0,0,.9);
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
    text-align: center;
    .promotionRuleBody {
      flex: 1;
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      .introduceImg {
        width: 90vw;
        margin: 20px auto 0;
        border-radius: 5px;
      }

      .rules {
        height: max-content;
        width: 90vw;
        padding-bottom: 84px;
        margin: 5px auto 20px auto;
        text-align: left;
        display: flex;
        flex-direction: column;
        table{
          flex-shrink: 0.1;
          width: 100% !important;
        }
      }

      .buttons-block {
        position: fixed;
        height: 84px;
        bottom: 60px;
        padding: 20px 0;
        background: #020202;
        width: 100%;
        text-align: center;

        .play-btn{
          display: block;
          width: 90vw;
          margin: 0 auto;
          background: #F6D9AA;
          border-radius: 6px;
          line-height: 20px;
          padding: 12px 0;
          text-align: center;
          color: #000D2E;
          font-size: 20px;
        }

        .invalid{
          background: #7f7d7a;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Promotion/rule.vue